const checkHubspotChatbotStatus = () =>
  window?.HubSpotConversations?.widget?.status();

export default checkHubspotChatbotStatus; 